var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h5", [
        _vm._v("\n    " + _vm._s(_vm.$t("Advertisables.view.title")) + "\n  ")
      ]),
      _vm._v(" "),
      _c(
        "post-list",
        {
          staticClass: "container",
          attrs: {
            editable: "",
            displayList: _vm.getPaginatedList,
            paginationInfo: _vm.getPaginationInfo
          },
          on: {
            deletePost: _vm.deletePost,
            requestPrevPage: function($event) {
              return _vm.requestPrevPage()
            },
            requestNextPage: function($event) {
              return _vm.requestNextPage()
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "select-inputs-products col-md-3 p-sm-0 col-sm-12",
              attrs: { slot: "filterSlot" },
              slot: "filterSlot"
            },
            [
              _c("input-select", {
                staticClass: "select-input",
                attrs: {
                  inputPlaceholder: _vm.$t(
                    "Campaigns.filterCategoriesPlaceholder"
                  ),
                  inputName: "category",
                  variant: "standardInput",
                  inputLabel: _vm.$t("Campaigns.filterCategories"),
                  small: "",
                  selectOptions: _vm.getAdvertisableCategories
                },
                on: { fieldUpdate: _vm.updateFilter }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "search-box-container col-md-3 p-sm-0 col-sm-12",
              attrs: { slot: "filterSlot" },
              slot: "filterSlot"
            },
            [
              _c("input-text", {
                staticClass: "col",
                attrs: {
                  iconRight: "search",
                  inputLabel: _vm.$t("Campaigns.findProduct"),
                  small: "",
                  regular: "",
                  variant: "standardInput",
                  inputPlaceholder: _vm.$t("Campaigns.findProduct"),
                  inputName: "query"
                },
                on: { fieldUpdate: _vm.updateFilter }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-295506fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-295506fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/service/postManager/PostViewer.vue
// module id = null
// module chunks = 